import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var _props;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "DollarInput",
  props: (_props = {
    type: {
      type: String,
      default: "text"
    },
    borderless: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: String
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean
    },
    errorMessage: {
      type: String
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    readOnly: {
      default: false
    },
    dense: {
      type: Boolean,
      default: true
    },
    value: null,
    prefix: {
      type: String,
      default: "$"
    }
  }, _defineProperty(_props, "filled", {
    type: Boolean
  }), _defineProperty(_props, "color", {
    type: String,
    default: "blue"
  }), _defineProperty(_props, "BGColor", {
    type: String,
    default: "white"
  }), _defineProperty(_props, "size", {
    type: String,
    default: "10px"
  }), _defineProperty(_props, "clearable", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "rounded", {
    type: Boolean
  }), _defineProperty(_props, "tooltip", {
    type: Boolean
  }), _defineProperty(_props, "toolValue", {
    type: String,
    default: "Add toolValue prop to change text"
  }), _defineProperty(_props, "label", {
    type: String
  }), _defineProperty(_props, "hint", {
    type: String
  }), _defineProperty(_props, "inputStyle", {
    type: String
  }), _defineProperty(_props, "required", {
    type: Boolean,
    default: false
  }), _defineProperty(_props, "rules", {}), _props),
  data: function data() {
    return {
      originalValue: null
    };
  },
  mounted: function mounted() {
    this.originalValue = this.value;
  },
  computed: {
    isDirty: function isDirty() {
      return this.value != "" && this.value != this.originalValue;
    }
  },
  methods: {
    isRequired: function isRequired() {
      if (this.required) {
        if (!this.value || this.value == 0) return "*Field is required";else return true;
      } else return true;
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
    }
  }
};